import { useMutation } from "@tanstack/react-query";

import { CONSOLE_API_ROUTES } from "@/config/apiConfig";
import consoleAxios from "@/service/axios/consoleAxios";

interface body {
    idx: number[];
}

// 게시글 첨부파일 영구삭제
export const useDelBoardFile = () => {
    return useMutation({
        mutationFn: async (body: body) => {
            const res = await consoleAxios.delete(CONSOLE_API_ROUTES.BOARD_FILE, {
                data: body,
            });
            return res.data;
        },
    });
};
